export enum UserRole {
    superAdmin = "superAdmin",
    admin = "admin",
    manager = "manager",
    user = "user"
}
